




















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import EventBus from '@/plugins/EventBus'
import { maskMoney, maskCPFCNPJ } from '@/utils/common'
import { jsPDF } from "jspdf";

@Component

export default class ComponentRecebimentoItemInstrucoes extends Vue {
  showDialogInstruirEmissaoDeNota: boolean = false
  instrucoesDefault: any = {
    valorBruto: 0,
    prestador: '',
    cnpjPrestador: '',
    fontePagadora: '',
    cnpjFontePagadora: '',
  }

  instrucoes: any = { ...this.instrucoesDefault }

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  maskCPFCNPJUtil(value) {
    return maskCPFCNPJ(value)
  }

  enviarEmail(){
    const destinatario = 'contato@exemplo.com.br'
    const assunto = 'Detalhes NF'
    const mensagem = `
      Seguem os dados para emissão da nota fiscal:

      Prestador de serviços:
      Nome: ${this.instrucoes.prestador}
      CNPJ: ${this.instrucoes.cnpjPrestador}

      Tomador de serviços:
      Nome: ${this.instrucoes.fontePagadora}
      CNPJ: ${this.instrucoes.cnpjFontePagadora}

      Valor: ${this.maskMoneyUtil(this.instrucoes.valorBruto)}

      Endereço:
      ${this.instrucoes.endereco ? this.instrucoes.endereco : '-'}

      Atenciosamente,
    `

    const subject = encodeURIComponent(`${assunto}`)
    const body = encodeURIComponent(`${mensagem}\n`)
    const mailto = `mailto:${destinatario}?subject=${subject}&body=${body}`
    window.location.href = mailto;
  }

   async getBase64FromUrl(url) {
      const res = await fetch(url);
      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }

  async baixarPdfInstrucoes(){
    const doc = new jsPDF({ unit: "mm", format: "a4" })
    const azul = "#1976D2";
    const cinza = "#555";
    const bgBox = "#f5f8fb";

    doc.setFontSize(16);
    doc.setTextColor(azul);
    doc.text("Dados para emissão da nota fiscal", 15, 22);

    doc.setFillColor(bgBox);
    doc.roundedRect(14, 29, 182, 18, 3, 3, "F");
    doc.setFontSize(12);
    doc.setTextColor(cinza);
    doc.text("Valor", 18, 35);
    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.setFont("helvetica", "bold");
    doc.text(String(this.maskMoneyUtil(this.instrucoes.valorBruto)), 18, 42, { align: "left" });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(azul);
    doc.text("Prestador de serviços", 14, 62);
    doc.setDrawColor("#ddd");
    doc.line(14, 64, 196, 64);

    doc.setFontSize(10);
    doc.setTextColor("#000");
    doc.text(`${this.instrucoes.prestador}`, 14, 70);
    doc.text(`CNPJ: ${this.instrucoes.cnpjPrestador}`, 14, 76);

    doc.setFontSize(11);
    doc.setTextColor(azul);
    doc.text("Tomador de serviços", 14, 90);
    doc.setDrawColor("#ddd");
    doc.line(14, 92, 196, 92);

    doc.setFontSize(10);
    doc.setTextColor("#000");
    doc.text(`${this.instrucoes.fontePagadora}`, 14, 98);
    doc.text(`CNPJ: ${this.instrucoes.cnpjFontePagadora}`, 14, 104);

    doc.setFontSize(11);
    doc.setTextColor(azul);
    doc.text("Endereço", 14, 118);
    doc.setDrawColor("#ddd");
    doc.line(14, 120, 196, 120);

    doc.setFontSize(10);
    doc.setTextColor("#000");
    doc.text(this.instrucoes.endereco ? this.instrucoes.endereco : '-', 14, 126);

    doc.setFontSize(10);
    doc.setTextColor(cinza);
    doc.text("Atenciosamente,", 14, 148);
    doc.text(this.instrucoes.prestador, 14, 154);
    
    doc.save(`nota-fiscal-${this.instrucoes.prestador}.pdf`);
  }

  @Watch('showDialogInstruirEmissaoDeNota')
  onChangeShowDialogInstruirEmissaoDeNota(value: boolean) {
    if (!value) {
      this.instrucoes = { ...this.instrucoesDefault }
    }
  }

  mounted() {
    EventBus.$on('instruirEmissaoDeNota', (data: any) => {
      this.showDialogInstruirEmissaoDeNota = data.open
      this.instrucoes = { ...data.instrucoes }
    })
  }
}

